
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class TaxTypesGrid extends Serenity.EntityGrid<TaxTypesRow, any> {
        protected getColumnsKey() { return TaxTypesColumns.columnsKey; }
        protected getDialogType() { return TaxTypesDialog; }
        protected getIdProperty() { return TaxTypesRow.idProperty; }
        protected getInsertPermission() { return TaxTypesRow.insertPermission; }
        protected getLocalTextPrefix() { return TaxTypesRow.localTextPrefix; }
        protected getService() { return TaxTypesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}